/* ======================================================================
   ANDHEKA — transitions + global UI (mega-menu, currency, mobile menu,
   Klaviyo signup). Cart behaviour lives in andheka-cart.js.
   ====================================================================== */
(function () {
  'use strict';
  var A = window.Andheka || {};
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var supportsMPAVT = ('onpageswap' in window) || ('onpagereveal' in window);
  var inEditor = !!(window.Shopify && window.Shopify.designMode);

  /* ---------- Dissolve (fallback for browsers without cross-doc view transitions) ---------- */
  if (A.enableDissolve && !supportsMPAVT && !reduce && !inEditor) {
    var dur = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--dissolve')) || 520;
    document.addEventListener('click', function (e) {
      var a = e.target.closest('a[href]');
      if (!a) return;
      if (a.target === '_blank' || a.hasAttribute('download') || a.dataset.noTransition !== undefined) return;
      var url = new URL(a.href, location.href);
      if (url.origin !== location.origin) return;
      if (url.pathname === location.pathname && url.hash) return;         // in-page anchor
      if (a.getAttribute('href').charAt(0) === '#') return;
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) return;
      e.preventDefault();
      document.body.classList.add('ac-leaving');
      setTimeout(function () { location.href = url.href; }, dur);
    });
    // If restored from bfcache, clear the leaving state
    window.addEventListener('pageshow', function () { document.body.classList.remove('ac-leaving'); });
  }

  /* ---------- Shop hover mega-menu ---------- */
  document.querySelectorAll('[data-mega]').forEach(function (trigger) {
    var panel = document.getElementById(trigger.dataset.mega);
    if (!panel) return;
    var header = trigger.closest('.ac-header');
    var closeT;
    function open() { clearTimeout(closeT); panel.classList.add('is-open'); if (header) header.classList.add('ac-shop-open'); }
    function close() { closeT = setTimeout(function () { panel.classList.remove('is-open'); if (header) header.classList.remove('ac-shop-open'); }, 70); }
    trigger.addEventListener('mouseenter', open);
    trigger.addEventListener('mouseleave', close);
    panel.addEventListener('mouseenter', open);
    panel.addEventListener('mouseleave', close);
    trigger.addEventListener('focus', open);
  });

  /* ---------- Header turns solid paper on scroll (home hero) ---------- */
  (function () {
    var hdr = document.querySelector('.ac-header');
    if (!hdr) return;
    var onScroll = function () {
      if (window.scrollY > 24) hdr.classList.add('is-scrolled');
      else hdr.classList.remove('is-scrolled');
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  })();

  /* ---------- Collection: client-side chapter switch + hover video ---------- */
  document.querySelectorAll('.ac-collection').forEach(function (sec) {
    /* cover turns to video on hover */
    sec.querySelectorAll('[data-hover-video]').forEach(function (v) {
      var card = v.closest('.ac-cl-card') || v.closest('a');
      if (!card) return;
      card.addEventListener('mouseenter', function () { try { v.currentTime = 0; var pr = v.play(); if (pr && pr.catch) pr.catch(function () {}); } catch (e) {} });
      card.addEventListener('mouseleave', function () { try { v.pause(); } catch (e) {} });
    });

    var chips = sec.querySelectorAll('[data-cl-soon],[data-cl-home]');
    if (!chips.length) return;
    var right = sec.querySelector('.ac-cl-right');
    var rail = right && right.querySelector('.ac-cl-rail');
    var view = right && right.querySelector('.ac-cl-soonview');
    var mob = sec.querySelector('.ac-cl-mob');
    var mgrid = mob && mob.querySelector('.ac-cl-mob-grid');
    var mview = mob && mob.querySelector('.ac-cl-mob-soon');
    var devaEl = sec.querySelector('.ac-cl-deva'), titleEl = sec.querySelector('.ac-cl-title'), mtitleEl = sec.querySelector('.ac-cl-mob-title'), mdevaEl = sec.querySelector('[data-mob-deva]');
    var homeDeva = devaEl ? devaEl.textContent : '', homeTitle = titleEl ? titleEl.textContent : '';

    function setLeft(deva, title) {
      if (devaEl) devaEl.textContent = deva || '';
      if (titleEl) titleEl.textContent = title || '';
      if (mtitleEl) mtitleEl.textContent = title || '';
      if (mdevaEl) mdevaEl.textContent = deva || '';
    }
    function fill(v, btn) {
      if (!v) return;
      var d = v.querySelector('[data-soon-deva]'), t = v.querySelector('[data-soon-title]'), p = v.querySelector('[data-soon-desc]');
      if (d) { d.textContent = btn.dataset.deva || ''; d.style.display = btn.dataset.deva ? '' : 'none'; }
      if (t) t.textContent = btn.dataset.label || '';
      if (p) p.textContent = btn.dataset.desc || 'This chapter has not opened yet.';
      v.hidden = false; v.setAttribute('aria-hidden', 'false');
    }
    chips.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        if (btn.hasAttribute('data-cl-home')) {
          if (rail) rail.style.display = ''; if (view) view.hidden = true;
          if (mgrid) mgrid.style.display = ''; if (mview) mview.hidden = true;
          setLeft(homeDeva, homeTitle);
        } else {
          if (rail) rail.style.display = 'none'; fill(view, btn);
          if (mgrid) mgrid.style.display = 'none'; fill(mview, btn);
          setLeft(btn.dataset.deva, btn.dataset.label);
        }
        sec.querySelectorAll('.ac-cl-slink, .ac-cl-mob-tab').forEach(function (l) { l.classList.remove('is-active'); });
        btn.classList.add('is-active');
      });
    });
  });

  /* ---------- Currency dropdowns ---------- */
  document.querySelectorAll('.ac-cur').forEach(function (wrap) {
    var btn = wrap.querySelector('.ac-cur-btn');
    var menu = wrap.querySelector('.ac-cur-menu');
    if (!btn || !menu) return;
    function setOpen(v) {
      btn.setAttribute('aria-expanded', v);
      if (v) { menu.hidden = false; } else { menu.hidden = true; }
    }
    btn.addEventListener('click', function (e) {
      e.stopPropagation();
      setOpen(btn.getAttribute('aria-expanded') !== 'true');
    });
    document.addEventListener('click', function (e) {
      if (!wrap.contains(e.target)) setOpen(false);
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') setOpen(false); });
  });

  /* ---------- Mobile menu half-sheet ---------- */
  var mm = document.querySelector('[data-mobile-menu]');
  if (mm) {
    function openMenu() { mm.hidden = false; void mm.offsetWidth; requestAnimationFrame(function () { mm.classList.add('is-open'); }); document.body.style.overflow = 'hidden'; }
    function closeMenu() { mm.classList.remove('is-open'); document.body.style.overflow = ''; setTimeout(function () { mm.hidden = true; }, 600); }
    document.querySelectorAll('[data-menu-open]').forEach(function (b) { b.addEventListener('click', openMenu); });
    document.querySelectorAll('[data-menu-close]').forEach(function (b) { b.addEventListener('click', closeMenu); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !mm.hidden) closeMenu(); });
  }

  /* ---------- Klaviyo email signup ---------- */
  document.querySelectorAll('[data-klaviyo]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var msg = form.querySelector('.ac-klaviyo-msg');
      var email = (form.querySelector('input[type=email]') || {}).value;
      var list = form.dataset.list || A.klaviyo && A.klaviyo.list;
      if (msg) msg.textContent = '';
      if (!list) { if (msg) msg.textContent = 'Add your Klaviyo List ID in theme settings.'; return; }
      if (!email) { if (msg) msg.textContent = 'Enter an email.'; return; }

      var body = new FormData();
      body.append('g', list);
      body.append('email', email);
      body.append('$fields', 'email');

      fetch('https://manage.kmail-lists.com/ajax/subscriptions/subscribe', {
        method: 'POST', body: body, mode: 'cors'
      })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (data && (data.success || data.data)) {
            if (msg) msg.textContent = 'You are with us.';
            form.reset();
          } else {
            if (msg) msg.textContent = (data && data.errors && data.errors[0]) || 'Please try again.';
          }
        })
        .catch(function () { if (msg) msg.textContent = 'Please try again.'; });
    });
  });
})();
